import component from './appeals.component';
import flows from './flows/flows.module';
import list from './list/list.component';
import listItem from './list/item/item.component';
import show from './show/show.module';
import wizard from './wizard/wizard.component';

export default angular.module('mpdx.tools.appeals', [component, flows, list, listItem, show, wizard]).name;
